export default {
  screens: [
    {
      type: 'intro',
      title: 'ジョゼフィーヌ、ショーメのミューズ',
      content:
        '1805年にショーメを御用達ジュエラーに選んだ皇后ジョゼフィーヌは、メゾンの大切なミューズとなりました。',
      idYt: 'gQZPa0SdueQ',
      videoCover: 'world/josephine/video.jpg',
      desktop: {
        cover: 'world/josephine/cover-1.jpg'
      },
      mobile: {
        cover: 'world/josephine/mobile-cover-1.jpg',
        contentStyle: { width: '95%' },
        titleStyle: { width: '60%' },
        coverStyle: {
          width: 'auto',
          width: '50%',
          bottom: '0',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'memento',
      img: 'world/josephine/memento.jpg',
      content:
        '植物が生い茂るマルティニーク島で生まれたジョゼフィーヌは、生涯に渡り、色鮮やかでエキゾチックなスタイルを愛しました。<br/><br/> 芸術、ファッション、装飾、植物に対する生まれながらの趣味を持ち合わせた彼女は、時代をリードする女性となります。',
      cover: 'world/josephine/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/cover-3.jpg'
      },
      mobile: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/mobile-cover-3.jpg',
        coverStyle: {
          width: '61%',
          top: '43%',
          left: '-19%',
          right: 'inherit',
          position: 'absolute'
        }
      },
      content:
        'ジョゼフィーヌの比類ないスタイルは、ショーメのクリエーションに絶えずインスピレーションを与え続け、ついには、彼女の名前を冠した、ティアラをモチーフにしたコレクションが誕生しました。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/josephine.js